// mock api
// import './_apis_';

// i18n
import './locales/i18n';

// highlight
import './utils/highlight';
// scroll bar
import 'simplebar/src/simplebar.css';

// editor
import 'react-quill/dist/quill.snow.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

// slick-carousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// lazy image
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import ReactDOM from 'react-dom';
// import { StrictMode } from 'react';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import {createRoot} from 'react-dom/client';

import { sprintf } from 'sprintf-js';
require('dotenv').config()

console.warn = () => {};
// console.error= ()=>{}

const originalError = console.error;
console.error = function (msg, ...args) {
  if (process?.env?.NODE_ENV == 'production') {
    return; // in productin don't print these
  }

  let m;
  try {
    m = sprintf(msg, ...args);
  } catch (error) {
    m = msg;
  }

  if (
    typeof msg === 'string' &&
    (m.includes('Each child in a list should have a unique "key" prop') ||
     m.includes('validateDOMNesting') ||
     m.includes('React does not recognize the') ||
     m.includes('Received `false` for a non-boolean attribute `indicator`') ||
     m.includes('The prop `data` is marked as required in `DateModal`') ||
     m.includes('Failed prop type: Invalid prop `minimumDate` of type `String` supplied to `DateRangePicker`, expected instance of `Date`.') ||
     m.includes('Failed prop type: The prop `spacing` of `Grid` can only be used together with the `container` prop.') ||
     m.includes('Invalid prop `minimumDate` of type `Moment` supplied to `DateRangePicker`, expected instance of `Date`.') ||
     m.includes('Failed prop type: Invalid prop `data` of type') ||
     m.includes('Failed prop type: The prop `md` of `Grid` can only be used together with the `item` prop.') ||
     m.includes('value` prop on `input` should not be null.') ||
     m.includes('A component is changing a controlled input to be uncontrolled.') ||
     m.includes('Failed prop type: The prop `data` is marked as required') ||
     m.includes('cannot be a descendant of') ||
     m.includes('cannot contain a nested')
     // /Received .*false.* for a non-boolean attribute .*indicator.*/.test(m)
    )
  ) {
    return; // Suppress
  }
  originalError.call(console, msg, ...args);
};


const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(<App />); // <StrictMode><App /></StrictMode>

serviceWorker.unregister();
reportWebVitals();
